<template>
  <div class="input-container" :class="variantClass" data-testid="select-container">
    <legend>{{ legend }}</legend>

    <ModelSelect
      v-if="filtered"
      class="input"
      :options="filteredOptions"
      v-model="internalValue"
      @input="$emit('update:modelValue', internalValue)"
      @searchchange="handleSearchChange"
      :placeholder="placeholder"
      :isDisabled="disabled"
      data-testid="model-select-filtered"
    >
    </ModelSelect>

    <ModelSelect
      v-else
      class="input"
      :options="options"
      v-model="internalValue"
      @input="$emit('update:modelValue', internalValue)"
      :placeholder="placeholder"
      :isDisabled="disabled"
      data-testid="model-select"
    >
    </ModelSelect>
  </div>
</template>

<script>
import { ModelSelect } from 'vue-search-select'

export default {
  name: 'Select',
  components: {
    ModelSelect,
  },
  props: {
    filtered: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Array,
      required: true,
    },
    legend: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    modelValue: {
      required: true,
    },
    variant: {
      type: String,
      default: 'default',
    },
  },
  data() {
    return {
      internalValue: this.modelValue,
      filteredOptions: [],
    }
  },
  computed: {
    variantClass() {
      return this.variant === 'dark' ? 'variant-dark' : 'default'
    },
  },
  methods: {
    handleSearchChange(e) {
      if (e) {
        const inputText = e.toLowerCase()

        this.filteredOptions = this.options
          .filter(option => option.text.toLowerCase().includes(inputText))
          .slice(0, 50)
      }
    },
  },
  watch: {
    modelValue(newVal) {
      this.internalValue = newVal
    },
  },
}
</script>

<style lang="scss" scoped>
.input-container {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  justify-content: space-between;
  position: relative;
  /* Remove z-index fixo para evitar criar um novo stacking context */

  legend {
    margin: 0;
    font-size: 1rem;
    font-weight: 600;
    line-height: 100%;
    color: #606264;
  }

  .input {
    min-width: 15.0625rem !important;
    height: 2.738125rem !important;
    border: 1px solid #eaeaea !important;
    border-radius: 4px !important;
    font-size: 1rem;
    font-weight: 600;
    line-height: 100%;
    position: relative;
  }

  &.variant-dark {
    legend {
      font-weight: 700;
      color: #1c2d5a;
    }

    .input {
      border: 1px solid #1c2d5a !important;
    }
  }
}
</style>

<style lang="scss">
/* Estilos não-scoped para o dropdown do vue-search-select */

/* Previne que inputs-row criem um stacking context que limite o dropdown */
.inputs-row {
  position: relative !important;
  z-index: auto !important;
}

/* Container do dropdown em estado normal */
.ui.fluid.dropdown {
  position: relative !important;
}

/* Quando o dropdown está ativo/aberto, eleva o z-index */
.ui.dropdown.active,
.ui.dropdown.visible {
  position: relative !important;
  z-index: 10000 !important;
}

.ui.dropdown.active.visible {
  position: relative !important;
  z-index: 10000 !important;
}

/* Menu do dropdown - sempre visível por cima de outros elementos */
.ui.dropdown .menu {
  position: absolute !important;
  z-index: 10001 !important;
  max-height: 300px !important;
  min-width: 100% !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  margin-top: 2px !important;
  background: white !important;
  border: 1px solid rgba(34, 36, 38, 0.15) !important;
  border-radius: 0.28571429rem !important;
  /* Garante que o dropdown não seja cortado */
  clip: auto !important;
  clip-path: none !important;
  contain: none !important;
}

/* Menu visível */
.ui.dropdown .menu.visible,
.ui.dropdown.active .menu,
.ui.dropdown.visible .menu {
  display: block !important;
  z-index: 10001 !important;
  visibility: visible !important;
  opacity: 1 !important;
}

/* Força z-index quando menu está visível e dropdown ativo */
.ui.dropdown.active .menu.visible {
  z-index: 10001 !important;
}

/* Itens do menu */
.ui.dropdown .menu > .item {
  position: relative !important;
  cursor: pointer !important;
  display: block !important;
  border: none !important;
  height: auto !important;
  text-align: left !important;
  border-top: none !important;
  line-height: 1em !important;
  color: rgba(0, 0, 0, 0.87) !important;
  padding: 0.78571429rem 1.14285714rem !important;
  font-size: 1rem !important;
  text-transform: none !important;
  font-weight: 400 !important;
  box-shadow: none !important;
  -webkit-touch-callout: none !important;
}

/* Hover nos itens do menu */
.ui.dropdown .menu > .item:hover {
  background: rgba(0, 0, 0, 0.05) !important;
}

/* Item selecionado */
.ui.dropdown .menu > .item.selected {
  background: rgba(0, 0, 0, 0.03) !important;
  font-weight: 600 !important;
}

/* Garante que o container pai do select tenha z-index adequado quando dropdown está aberto */
/* Usando seletor compatível com todos os navegadores */
.input-container {
  isolation: auto !important;
}
</style>
